'use client';

import { IconShow } from 'src/general/Icons/IconShow';
import { Link } from 'src/general/components/Link/Link';
import { ControlInputGroup } from 'src/general/components/forms/Input/ControlInput/ControlInputGroup';
import { Switch } from 'src/general/components/forms/Input/atoms/OptionFieldInput';
import { getPlpUrlWithAvailableFilter } from 'src/plp/helpers/getPlpUrlWithFilter';
import { isPlpNoFollow } from 'src/plp/helpers/isPlpNoFollow';
import { FilterParams } from '../../PlpFilters.type';

type Props = {
  params: FilterParams;
};

export const AvailableFilterLink = ({ params }: Props) => {
  const href = getPlpUrlWithAvailableFilter(params);
  const nofollow = isPlpNoFollow(href);
  const value = params.filter.includes('available') ? 'available' : '';
  return (
    <Link href={href} rel={nofollow ? 'nofollow' : undefined} className="AvailableFilter">
      <div className="AvailableFilter-wrapper">
        <IconShow />
        <ControlInputGroup
          id="state"
          name="state"
          type="switch"
          variant="isolated"
          inputIcon={Switch}
          options={[{ label: 'Show available only', value: 'available' }]}
          inputPlacement="end"
          className="AvailableFilter-switch"
          value={value}
        />
      </div>
    </Link>
  );
};
